import { Typography } from "@mui/material";
import { useAppSelector } from "redux/hooks";
import Item from "./item";
import { Notification } from "./Notifications";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeNotificationsHandler: () => void;
  handleDeleteNotification: any;
}

function List(props: Props) {
  const { setOpen, closeNotificationsHandler, handleDeleteNotification } = props;
  const notifications = useAppSelector((state) => state.Notifications.data.list);

  return (
    <>
      {notifications.length ? (
        notifications.map((notification: Notification) => {
          return (
            <Item
              handleDeleteNotification={handleDeleteNotification}
              closeNotificationsHandler={closeNotificationsHandler}
              key={notification.id}
              item={notification}
              setOpen={setOpen}
            />
          );
        })
      ) : (
        <Typography>You don't have any notifications</Typography>
      )}
    </>
  );
}

export default List;
